import styles from './About.module.css';
import { site } from '../content/site.js';
import Reveal from './Reveal.jsx';

export default function About() {
  const a = site.about;
  return (
    <section className={styles.about} id="about">
      <header className="section-head">
        <span className="num" aria-hidden="true">{a.num}</span>
        <h2>{a.title}</h2>
        <p className="meta">{a.meta}</p>
      </header>
      <div className={styles.body}>
        <Reveal as="p">{a.body1}</Reveal>
        <Reveal delay={0.08}>
          <p className={styles.lede}>{a.body2}</p>
          {a.facts.map((f, i) => (
            <span key={i}>
              {f}
              {i < a.facts.length - 1 && <br />}
            </span>
          ))}
        </Reveal>
      </div>

    </section>
  );
}
